import { render, staticRenderFns } from "./adminToolImport.vue?vue&type=template&id=70c1cb20&"
import script from "./adminToolImport.vue?vue&type=script&lang=js&"
export * from "./adminToolImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports